module.exports = __webpack_public_path__ + "img/ecommerce-card-img.b403d42d.png";